// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"99ae94e8","602":"4a7cc43f","880":"9c24c28d"}[chunkId] + ".chunk.css";
};